var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<p class=\'padding-top-sm\'>\nPersons who may contact you include real estate professionals such as agents and brokers, mortgage professionals such as lenders and\nmortgage brokers (if the scope of your inquiry included pre-approval or mortgage), realtor.com and its affiliates, and those who may be assisting any of the foregoing.\n</p>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/lcm_others_disclaimer.jst.ejs